module.exports = __webpack_public_path__ + "static/media/home.12d0fb0e.svg";